<template>
  <div id="app">
    <v-app id="inspire" light>
      <cariKodDegis ref="cariKodDegis"></cariKodDegis>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"
                >{{ $t('Auxiliary-Processes') }}</v-toolbar-title
              >
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">
              <v-btn
                style="width: 400px"
                color="info"
                @click="kodDialogAc()"
                dark
                >{{ $t("Do-Not-Change-Current-Code") }}
                <v-icon right dark>call_to_action</v-icon>
              </v-btn>
              <!-- <router-link
                :to="{ name: 'yardimci-islemler-carisizbiletlistesi' }"
              >
                <v-btn style="width: 400px" color="info" dark
                  > {{ $t('List-Tickets-Without-Current-Processes') }}
                  <v-icon right dark>airplane_ticket</v-icon>
                </v-btn>
              </router-link> -->

              <router-link
               :to="{ name: 'yardimci-islemler-carisizbiletlistesi' }"
              >
                <v-btn style="width: 400px" color="info" dark
                  >{{$t('List-Tickets-Without-Current-Processes')}}
                  <v-icon right dark>call_to_action</v-icon>
                </v-btn>
              </router-link>


              <router-link
                :to="{ name: 'aktarim-cari-excel' }"
              >
                <v-btn style="width: 400px" color="info" dark
                  > {{$t('Current-Transfer-Excel')}}
                  <v-icon right dark>call_to_action</v-icon>
                </v-btn>
              </router-link>
  <router-link
                :to="{ name: 'aktarim-carihareket-excel' }"
              >
                <v-btn style="width: 400px" color="info" dark
                  > {{$t('Current-Movement-Transfer')}}
                  <v-icon right dark>call_to_action</v-icon>
                </v-btn>
              </router-link>
              <router-link
                :to="{ name: 'yardimci-islemler-muhasebekodupdate' }"
              >
                <v-btn style="width: 400px" color="info" dark
                  > Cari Kart Muhasebe Kod Güncelleme - Excel   <v-icon right dark>call_to_action</v-icon>
                </v-btn>
              </router-link>



            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import cariKodDegis from "@/components/app/cari/yardimciislemler/comp/cariKodDegis";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  filters: {},
  components: {
    cariKodDegis,
  },
  methods: {
    kodDialogAc() {
      this.$refs.cariKodDegis.open();
    },
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};

function beforeMount() {}
</script>
